import { BusinessInterests } from 'src/components/Quiz/BusinessInterests';
import { CollegeGpa } from 'src/components/Quiz/CollegeGpa';
import { Credits } from 'src/components/Quiz/Credits';
import { Education } from 'src/components/Quiz/Education';
import { Feeling } from 'src/components/Quiz/Feeling';
import { FeelingFeedback } from 'src/components/Quiz/FeelingFeedback';
import { Goal } from 'src/components/Quiz/Goal';
import { HealthcareInterests } from 'src/components/Quiz/HealthcareInterests';
import { HighSchoolGpa } from 'src/components/Quiz/HighSchoolGpa';
import { Interests } from 'src/components/Quiz/Interests';
import { LoadingResults } from 'src/components/Quiz/LoadingResults';
import { OptIn } from 'src/components/Quiz/OptIn';
import { ProgramFactor } from 'src/components/Quiz/ProgramFactor';
import { TechInterests } from 'src/components/Quiz/TechInterests';
import { TuitionInfo } from 'src/components/Quiz/TuitionInfo';
import { WeeklyTime } from '@src/components/Quiz/WeeklyTime/WeeklyTime';
import { Welcome } from 'src/components/Quiz/Welcome';
import { TimeToComplete } from '@src/components/Quiz/TimeToComplete';
import { employerIds } from '@src/constants/employerResources';
import { EducationValues, ScreenGroups, ScreenProps, Screens } from './types';

export type QuizMappingType = {
	[key in Screens]: {
		nextScreen?: { [key: string]: Screens; default: Screens };
		screenGroup: ScreenGroups;
	};
};

export const screens: { [key in Screens]: React.FC<ScreenProps> } = {
	[Screens.OPTIN]: OptIn,
	[Screens.WELCOME_1]: Welcome,
	[Screens.WELCOME_2]: TuitionInfo,
	[Screens.FEELING_1]: Feeling,
	[Screens.FEELING_2]: FeelingFeedback,
	[Screens.EDUCATION]: Education,
	[Screens.GOAL]: Goal,
	[Screens.HS_GPA]: HighSchoolGpa,
	[Screens.COLLEGE_GPA]: CollegeGpa,
	[Screens.CREDITS]: Credits,
	[Screens.INTERESTS]: Interests,
	[Screens.TECH_INTERESTS]: TechInterests,
	[Screens.BUSINESS_INTERESTS]: BusinessInterests,
	[Screens.HEALTHCARE_INTERESTS]: HealthcareInterests,
	[Screens.TIME_TO_COMPLETE]: TimeToComplete,
	[Screens.WEEKLY_TIME]: WeeklyTime,
	[Screens.FACTOR]: ProgramFactor,
	[Screens.LOADING]: LoadingResults,
};

export const defaultScreenGroupOrder = [
	ScreenGroups.FEELING,
	ScreenGroups.EDUCATION,
	ScreenGroups.INTERESTS,
	ScreenGroups.TIME_TO_COMPLETE,
	ScreenGroups.WEEKLY_TIME,
	ScreenGroups.FACTOR,
];

export const defaultScreenMap: QuizMappingType = {
	[Screens.OPTIN]: {
		nextScreen: { default: Screens.WELCOME_1 },
		screenGroup: ScreenGroups.WELCOME,
	},
	[Screens.WELCOME_1]: {
		nextScreen: {
			[employerIds.disney]: Screens.WELCOME_2,
			[employerIds.walmart]: Screens.WELCOME_2,
			default: Screens.FEELING_1,
		},
		screenGroup: ScreenGroups.WELCOME,
	},
	[Screens.WELCOME_2]: {
		nextScreen: { default: Screens.FEELING_1 },
		screenGroup: ScreenGroups.WELCOME,
	},

	[Screens.FEELING_1]: {
		nextScreen: { default: Screens.FEELING_2 },
		screenGroup: ScreenGroups.FEELING,
	},
	[Screens.FEELING_2]: {
		nextScreen: { default: Screens.EDUCATION },
		screenGroup: ScreenGroups.FEELING,
	},

	[Screens.EDUCATION]: {
		nextScreen: { default: Screens.GOAL },
		screenGroup: ScreenGroups.EDUCATION,
	},
	[Screens.GOAL]: {
		nextScreen: {
			[EducationValues['High school diploma']]: Screens.HS_GPA,
			[EducationValues['Some college credits']]: Screens.HS_GPA,
			[EducationValues['Associate degree']]: Screens.COLLEGE_GPA,
			[EducationValues["Bachelor's degree"]]: Screens.COLLEGE_GPA,
			[EducationValues["Master's degree or higher"]]: Screens.COLLEGE_GPA,
			default: Screens.FACTOR,
		},
		screenGroup: ScreenGroups.EDUCATION,
	},
	[Screens.HS_GPA]: {
		nextScreen: {
			[EducationValues['Some college credits']]: Screens.COLLEGE_GPA,
			default: Screens.INTERESTS,
		},
		screenGroup: ScreenGroups.EDUCATION,
	},
	[Screens.COLLEGE_GPA]: {
		nextScreen: {
			[EducationValues['Some college credits']]: Screens.CREDITS,
			default: Screens.INTERESTS,
		},
		screenGroup: ScreenGroups.EDUCATION,
	},
	[Screens.CREDITS]: {
		nextScreen: { default: Screens.INTERESTS },
		screenGroup: ScreenGroups.EDUCATION,
	},
	[Screens.INTERESTS]: {
		nextScreen: {
			Technology: Screens.TECH_INTERESTS,
			Business: Screens.BUSINESS_INTERESTS,
			Healthcare: Screens.HEALTHCARE_INTERESTS,
			default: Screens.TIME_TO_COMPLETE,
		},
		screenGroup: ScreenGroups.INTERESTS,
	},
	[Screens.TECH_INTERESTS]: {
		nextScreen: {
			Business: Screens.BUSINESS_INTERESTS,
			Healthcare: Screens.HEALTHCARE_INTERESTS,
			default: Screens.TIME_TO_COMPLETE,
		},
		screenGroup: ScreenGroups.INTERESTS,
	},
	[Screens.BUSINESS_INTERESTS]: {
		nextScreen: {
			Healthcare: Screens.HEALTHCARE_INTERESTS,
			default: Screens.TIME_TO_COMPLETE,
		},
		screenGroup: ScreenGroups.INTERESTS,
	},
	[Screens.HEALTHCARE_INTERESTS]: {
		nextScreen: { default: Screens.TIME_TO_COMPLETE },
		screenGroup: ScreenGroups.INTERESTS,
	},
	[Screens.TIME_TO_COMPLETE]: {
		nextScreen: { default: Screens.WEEKLY_TIME },
		screenGroup: ScreenGroups.TIME_TO_COMPLETE,
	},
	[Screens.WEEKLY_TIME]: {
		nextScreen: { default: Screens.FACTOR },
		screenGroup: ScreenGroups.WEEKLY_TIME,
	},
	[Screens.FACTOR]: {
		nextScreen: { default: Screens.LOADING },
		screenGroup: ScreenGroups.FACTOR,
	},

	[Screens.LOADING]: {
		screenGroup: ScreenGroups.LOADING,
	},
};
